var ConfirmationPopoverOptions = (function () {
    function ConfirmationPopoverOptions() {
        this.confirmText = 'Confirm';
        this.cancelText = 'Cancel';
        this.confirmButtonType = 'success';
        this.cancelButtonType = 'default';
        this.placement = 'top';
        this.hideConfirmButton = false;
        this.hideCancelButton = false;
        this.popoverClass = '';
        this.appendToBody = false;
    }
    return ConfirmationPopoverOptions;
}());
export { ConfirmationPopoverOptions };
//# sourceMappingURL=confirmation-popover-options.provider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-confirmation-popover/dist/esm/src/confirmation-popover-options.provider.js
// module id = 99
// module chunks = 9